import base64 from "base-64";

/* 
  test data is base64 encoded 
  to prevent browser users from 
  easily reading the network data being sent
*/
export function decodeBackend(encoded) {
  return JSON.parse(base64.decode(encoded));
}